import React from 'react';
import { Box, Container, Paper } from '@mui/material';
import LanguageToggle from './LanguageToggle';
import {
  BRAND_ATMOSPHERE,
  BRAND_GRADIENT,
  BRAND_SHADOW_CARD,
} from '../../brand/brand';

/**
 * The shared shell for every screen a provider sees before the dashboard: the Anipaw purple
 * field, the atmosphere highlights, and one white card that carries the content.
 *
 * Card content rises in on mount; `BrandScreen` owns the animation so login, signup and the
 * application-status screens all enter identically. It also owns the language toggle, so the
 * switch does not disappear as a provider moves between these screens.
 */
const BrandScreen = ({ maxWidth = 'sm', children }) => (
  <Box
    sx={{
      minHeight: '100vh',
      background: BRAND_GRADIENT,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      py: { xs: 4, sm: 6 },
      px: 2,
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        background: BRAND_ATMOSPHERE,
        pointerEvents: 'none',
      },
    }}
  >
    <LanguageToggle />
    <Container maxWidth={maxWidth} disableGutters sx={{ position: 'relative' }}>
      <Paper
        elevation={0}
        sx={{
          position: 'relative',
          overflow: 'hidden',
          p: { xs: 3, sm: 5 },
          borderRadius: '28px',
          boxShadow: BRAND_SHADOW_CARD,
          // The brand hairline across the top edge of the card.
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 4,
            background: BRAND_GRADIENT,
          },
          '@keyframes brandCardIn': {
            from: { opacity: 0, transform: 'translateY(14px)' },
            to: { opacity: 1, transform: 'none' },
          },
          animation: 'brandCardIn 420ms cubic-bezier(0.22, 1, 0.36, 1) both',
          '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
        }}
      >
        {children}
      </Paper>
    </Container>
  </Box>
);

export default BrandScreen;
